import { Dropdown, Button, Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  selectStatistic,
  updateStatisticSource,
} from "../StateManagement/statisticSourceSlice";
import { selectDisplay3D, updateDisplay3D } from "../StateManagement/display3DSlice";
import { statistics } from "../Data/statisticSource";

const DataDropDown = () => {
  const statistic = useSelector(selectStatistic);
  const display3D = useSelector(selectDisplay3D);
  const dispatch = useDispatch();

  // Function to create onClick handler for a statistic key
  const createOnClickHandler = (statisticKey) => () => {
    dispatch(updateStatisticSource(statistics[statisticKey]));
  };

  // Generate Dropdown items dynamically
  const dropdownItems = Object.keys(statistics).map((statKey) => (
    <Dropdown.Item key={statKey} onClick={createOnClickHandler(statKey)}>
      {statistics[statKey].description}
    </Dropdown.Item>
  ));

  return (
    <Container className="d-flex justify-content-center">
      <Row className="align-items-center">
        <Col xs="auto">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              {statistic.description}
            </Dropdown.Toggle>
            <Dropdown.Menu>{dropdownItems}</Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col xs="auto">
          <Button
            variant={display3D ? "primary" : "outline-primary"}
          
            onClick={() => dispatch(updateDisplay3D(!display3D))}
          >
            3D {display3D ? "On" : "Off"}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default DataDropDown;
